module.exports = __webpack_public_path__ + "img/phone-grey.001f430f.svg";